import { useEffect, useState } from "react";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { db } from "../firebase";
import type { Subscription } from "@acruxsoft/platform-shared";
import { useAuthCtx } from "../lib/auth-provider";

export function useActiveSubscription() {
  const { user } = useAuthCtx();
  const [sub, setSub] = useState<Subscription | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Reset on every user transition (including null→set on initial auth hydration).
    // Without this, when user starts null then gets set, subLoading stays false from
    // the prior !user branch and /account renders briefly with sub=null (so hasPaidSub
    // is false, upgrade promo flashes) before the listener delivers the real sub.
    setLoading(true);
    setSub(null);
    if (!user) { setLoading(false); return; }
    const q = query(
      collection(db, "subscriptions"),
      where("uid", "==", user.uid),
      where("status", "in", ["pending", "active", "past_due", "cancelled"])
    );
    return onSnapshot(q, (snap) => {
      const docs = snap.docs.map((d) => d.data() as Subscription);
      const active = docs.find((d) => d.status === "active" || d.status === "past_due") ?? docs[0] ?? null;
      setSub(active);
      setLoading(false);
    });
  }, [user]);

  return { sub, loading };
}
